import React, { useState } from "react";
import im2 from "../../assets/Group 627725.png";
import im1 from "../../assets/Group 627726.png";
import im from "../../assets/Group 627727.png";
import im3 from "../../assets/Vector.png";

// Step Component
const Step = ({ image, title, description }) => (
  <div className="w-full md:w-[27%]">
    <div className="flex flex-col items-center">
      <img src={image} alt={title} />
    </div>
    <div className="text-xl sm:text-2xl font-medium text-center">{title}</div>
    <div className="text-sm sm:text-base font-light text-center">
      {description}
    </div>
  </div>
);

// Feature Component
const Feature = ({ title, description, isActive, onClick }) => (
  <div className="border border-gray-300 rounded-lg overflow-hidden shadow-md">
    {/* Header Section */}
    <div
      className={`p-4 flex justify-between items-center cursor-pointer ${
        isActive ? "bg-gray-200" : "bg-white"
      }`}
      onClick={onClick}
    >
      <div className="text-lg font-semibold">{title}</div>
      <div className="text-xl">{isActive ? "−" : "+"}</div>
    </div>
    {/* Description Section */}
    {isActive && (
      <div className="p-4 bg-white text-sm text-gray-700 border-t">
        {description.split("\n").map((line, index) => {
          if (line.trim() === "✅") return null; // Skip standalone ✅
          return (
            <div key={index} className="flex items-start mb-1">
              {line.includes("✅") ? (
                <span className="mr-2" role="img" aria-label="checkmark">
                  ✅
                </span>
              ) : null}
              <span>{line.replace("✅", "").trim()}</span>
            </div>
          );
        })}
      </div>
    )}
  </div>
);

// WhyKahaApp Component
const WhyKahaApp = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const features = [
    {
      title: "One App for All Your Needs",
      description: `KahaApp brings together features like navigation, digital business tools, communication, and cultural heritage into one seamless platform. Whether you’re a traveler, a business owner, or a local resident, KahaApp caters to your diverse needs in a user-friendly interface.\n✅ Simplify your life with an all-in-one solution.`,
    },
    {
      title: "Simplified Digital Addressing",
      description: `KahaTAG provides every location with a unique, shareable digital address, replacing complex, traditional addresses. Businesses, landmarks, and personal locations become easier to find and share with pinpoint accuracy.\n✅ Transform the way you navigate and share locations effortlessly.`,
    },
    {
      title: "Verified Profiles for Trust",
      description: `All businesses and service providers listed on KahaApp undergo a thorough verification process to ensure they are legitimate and reliable.\n✅ Experience peace of mind while exploring verified services.`,
    },
    {
      title: "Immersive Visual Experiences",
      description: `KahaApp allows businesses and users to showcase and explore locations with 360° photos and videos.\n✅ Enjoy a virtual preview of your destination to build trust and excitement.`,
    },
    {
      title: "Seamless Communication",
      description: `Integrated chat and call features let users directly interact with businesses and service providers within the app.\n✅ Save time and connect instantly for inquiries or bookings.`,
    },
    {
      title: "Boost Your Business Visibility",
      description: `KahaApp offers digital ad spaces, notice boards, and push notifications that help businesses promote their offerings.\n✅ Maximize your reach and attract customers with strategic visibility.`,
    },
    {
      title: "Navigate with Precision",
      description: `Our navigation tool provides accurate, step-by-step directions to businesses, tourist landmarks, and essential services.\n✅ Travel stress-free with detailed and reliable route guidance.`,
    },
    {
      title: "Local Shopping Made Easy",
      description: `The Digital Marketplace within KahaApp connects users to a variety of local businesses.\n✅ Support local businesses while enjoying the convenience of shopping online.`,
    },
    {
      title: "Transparent Feedback System",
      description: `KahaApp’s review and rating system empowers users to share honest feedback.\n✅ Build trust and transparency through user-generated insights.`,
    },
    {
      title: "Heritage & Cultural Connection Through Souvenirs",
      description: `KahaApp promotes Nepal’s rich heritage with exclusive souvenirs inspired by cultural and historical landmarks.\n✅ Celebrate Nepal’s culture and support heritage preservation.`,
    },
  ];

  const handleToggle = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="py-16 px-6 xl:px-0 bg-white">
      <div className="w-full xl:w-2xl mx-auto">
        <div
          className="font-bold text-3xl sm:text-4xl text-center mb-8 md:mb-14"
          data-aos="zoom-out-down"
        >
          Why KahaApp?
        </div>
        <div className="space-y-4">
          {features.map((feature, index) => (
            <Feature
              key={index}
              title={feature.title}
              description={feature.description}
              isActive={activeIndex === index}
              onClick={() => handleToggle(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

// StartWith Component
const StartWith = () => {
  return (
    <>
      {/* Why KahaApp Section */}
      <WhyKahaApp />

      {/* How to Start with KahaApp Section */}
      <div className="flex flex-col justify-center items-center py-16 md:py-28 bg-gray-100">
        <div className="w-full px-6 xl:px-0 xl:w-2xl">
          <div
            className="font-bold text-3xl sm:text-4xl text-center mb-8 md:mb-14"
            data-aos="zoom-out-down"
          >
            How to start with Kaha App
          </div>
          <div
            className="flex-col md:flex md:flex-row justify-between space-y-6 md:space-y-0"
            data-aos="zoom-in-up"
          >
            <Step
              image={im}
              title="Download Our App"
              description="Download KAHA APP from Play store or Apple store."
            />
            <div className="hidden md:flex flex-col justify-center">
              <img src={im3} alt="start1" />
            </div>
            <Step
              image={im1}
              title="Get Tagged"
              description="Open the application and tag your home/office/organization/entities."
            />
            <div className="hidden md:flex flex-col justify-center">
              <img src={im3} alt="star" />
            </div>
            <Step
              image={im2}
              title="Relax"
              description="Enjoy the ease of sharing this digital address (tag) for navigation and location sharing."
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default StartWith;
